import { PieChart } from '@mui/x-charts/PieChart';
import ChartCard from '../../analytics/ChartCard';
import { ErrorDistribution } from '../../../../types/admin';

interface ErrorDistributionPieProps {
  data: ErrorDistribution[];
  loading?: boolean;
}

export default function ErrorDistributionPie({ data, loading }: ErrorDistributionPieProps) {
  const chartData = data.map((d, index) => ({
    id: index,
    value: d.count,
    label: d.type,
  }));

  return (
    <ChartCard title="Errors by Type" subtitle="Distribution of error types" loading={loading} height={400}>
      <PieChart
        series={[
          {
            data: chartData,
            highlightScope: { faded: 'global', highlighted: 'item' },
            faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
          },
        ]}
        slotProps={{
          legend: {
            direction: 'column',
            position: { vertical: 'middle', horizontal: 'right' },
            padding: 0,
          },
        }}
      />
    </ChartCard>
  );
}
